<template>
    <h1>Workout Noter</h1>
</template>
